import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { NavigationGuardProvider } from "./context/NavigationGuardContext";
import "./index.css";
import "@legal-500/legal500-design-system/legal500-design-system.css";
import { FronteggProvider } from "@frontegg/react";
import { datadogRum } from "@datadog/browser-rum";
import { publicRuntimeConfig } from "./config/publicRuntimeConfig";

const root = document.getElementById("root");

const isAuthDisabled = publicRuntimeConfig.authDisabled;

const contextOptions = publicRuntimeConfig.frontegg;

const authOptions = {
  keepSessionAlive: true,
  sessionOptions: {
    persistSession: true,
    useRefreshToken: true,
    refreshTokenCookie: {
      httpOnly: true,
      secure: true,
      sameSite: "none",
    },
  },
};

const rum = publicRuntimeConfig.datadogRum;

if (
  rum.applicationId &&
  rum.clientToken &&
  rum.applicationId !== "CHANGE-ME" &&
  rum.clientToken !== "CHANGE-ME"
) {
  datadogRum.init({
    applicationId: rum.applicationId,
    clientToken: rum.clientToken,
    site: rum.site,
    service: rum.service,
    env: rum.env,
    version: rum.version,
    sessionSampleRate: rum.sessionSampleRate,
    sessionReplaySampleRate: rum.sessionReplaySampleRate,
    trackResources: rum.trackResources,
    trackLongTasks: rum.trackLongTasks,
    trackUserInteractions: rum.trackUserInteractions,
    defaultPrivacyLevel: "mask-user-input",
    ...(rum.allowedTracingUrls.length > 0
      ? {
          allowedTracingUrls: rum.allowedTracingUrls,
          traceSampleRate: rum.sessionSampleRate,
        }
      : {}),
    ...(rum.eventRateLimit === undefined ? {} : { eventRateLimit: rum.eventRateLimit }),
  });
}

if (!root) {
  throw new Error("Root element not found");
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <NavigationGuardProvider>
        {isAuthDisabled ? (
          <App />
        ) : (
          <FronteggProvider
            contextOptions={contextOptions}
            hostedLoginBox={true}
            authOptions={authOptions}
          >
            <App />
          </FronteggProvider>
        )}
      </NavigationGuardProvider>
    </BrowserRouter>
  </StrictMode>,
);
